"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
var adherev_util_dict_1 = __importDefault(require("@baifendian/adherev-util-dict"));
exports.default = {
    initStatic: function () {
        adherev_util_dict_1.default.handlers.ResourceMomentFormat2 = function () { return 'YY'; };
        adherev_util_dict_1.default.handlers.ResourceMomentFormat4 = function () { return 'YYYY'; };
        adherev_util_dict_1.default.handlers.ResourceMomentFormat6 =
            function () {
                return function (split) {
                    if (split === void 0) { split = '-'; }
                    return "YYYY".concat(split, "M");
                };
            };
        adherev_util_dict_1.default.handlers.ResourceMomentFormat7 =
            function () {
                return function (split) {
                    if (split === void 0) { split = '-'; }
                    return "YYYY".concat(split, "MM");
                };
            };
        adherev_util_dict_1.default.handlers.ResourceMomentFormat8 =
            function () {
                return function (split) {
                    if (split === void 0) { split = '-'; }
                    return "YYYY".concat(split, "M").concat(split, "D");
                };
            };
        adherev_util_dict_1.default.handlers.ResourceMomentFormat10 =
            function () {
                return function (split) {
                    if (split === void 0) { split = '-'; }
                    return "YYYY".concat(split, "MM").concat(split, "DD");
                };
            };
        adherev_util_dict_1.default.handlers.ResourceMomentFormat13 =
            function () {
                return function (split1, split2) {
                    if (split1 === void 0) { split1 = '-'; }
                    if (split2 === void 0) { split2 = ':'; }
                    return "YYYY".concat(split1, "M").concat(split1, "D H").concat(split2, "m").concat(split2, "s");
                };
            };
        adherev_util_dict_1.default.handlers.ResourceMomentFormat15 =
            function () {
                return function (split1, split2) {
                    if (split1 === void 0) { split1 = '-'; }
                    if (split2 === void 0) { split2 = ':'; }
                    return "YYYY".concat(split1, "MM").concat(split1, "DD H").concat(split2, "m").concat(split2, "s");
                };
            };
        adherev_util_dict_1.default.handlers.ResourceMomentFormat16 =
            function () {
                return function (split1, split2) {
                    if (split1 === void 0) { split1 = '-'; }
                    if (split2 === void 0) { split2 = ':'; }
                    return "YYYY".concat(split1, "M").concat(split1, "D HH").concat(split2, "mm").concat(split2, "ss");
                };
            };
        adherev_util_dict_1.default.handlers.ResourceMomentFormat18 =
            function () {
                return function (split1, split2) {
                    if (split1 === void 0) { split1 = '-'; }
                    if (split2 === void 0) { split2 = ':'; }
                    return "YYYY".concat(split1, "MM").concat(split1, "DD HH").concat(split2, "mm").concat(split2, "ss");
                };
            };
    },
};
